import moment from 'moment'

const ranges = [
  {
    label: 'This Week',
    value: 'thisWeek',
    generateRange: () => ({
      fromDate: moment().startOf('week'),
      toDate: moment().endOf('week'),
    }),
  },
  {
    label: 'This Month',
    value: 'thisMonth',
    generateRange: () => ({
      fromDate: moment().startOf('month'),
      toDate: moment().endOf('month'),
    }),
  },
  {
    label: 'Next Month',
    value: 'nextMonth',
    generateRange: () => {
      return {
        fromDate: moment().add(1, 'month').startOf('month'),
        toDate: moment().add(1, 'month').endOf('month'),
      }
    },
  },
  {
    label: 'Custom',
    value: 'custom',
  },
]

export default ranges
